import type { AgreementDetails } from '../../../../../types/isomorphic/agreementDetails.types';
import type { BannerRule } from '../types';

export const ENTERPRISE_CONTACT_SALES_FORM_ID = '701Pm00001Swdq0IAB';
export const ENTERPRISE_CONTACT_SALES_FORM_SOURCE =
  'GI_Site_EnterpriseService ';

type BatchAgreementRuntime = AgreementDetails & {
  effectivePermissions?: string[];
  authorizedAssets?: { assetId: string }[];
};

const batchZeroDownloadsRule: BannerRule = (
  { batchAgreements, siteMap },
  t
) => {
  if (!batchAgreements || batchAgreements.length === 0) return null;

  const allExhausted = (batchAgreements as BatchAgreementRuntime[]).every(
    (agreement) => {
      if (!agreement.isExhausted) return false;
      const hasOverage =
        agreement.effectivePermissions?.includes('DownloadOverage') ?? false;
      const hasAuthorizedAssets = (agreement.authorizedAssets?.length ?? 0) > 0;
      return !(hasOverage && hasAuthorizedAssets);
    }
  );

  if (!allExhausted) return null;

  return {
    severity: 'warning',
    heading: t('downloads_remaining_monthly_count', { count: 0 }),
    description: t('need_more_monthly_downloads_contact_us', {
      links: [
        {
          href: siteMap.enterpriseContactSalesForm(
            ENTERPRISE_CONTACT_SALES_FORM_ID,
            ENTERPRISE_CONTACT_SALES_FORM_SOURCE
          ),
        },
      ],
    }),
    rawHtml: true,
  };
};

export default batchZeroDownloadsRule;
